import React, { Component } from "react";
import { observer } from "mobx-react";
import KakaoMap from "../../../../utils/KakaoMap";
import NaverMapComponent from "utils/NaverMapComponent";
import { select_addr_forkakao, select_addr_keyword_forkakao } from "../../../../http/kakaoConn";
import { select_addr_fornaver } from "http/addrConn"
import AddressSearchViewItem from "./sub/AddressSearchViewItem";
import { fn_update_address, fn_address_api } from "../../../../function/FnBodyStep";
import { fn_add_box_show } from "../../../../function/FnBodyLayer";


@observer
class AddressSearchView extends Component {

    constructor(props) {
        super(props);
        this.state = { addressScroll: 0, keywordScroll: 0 }
        this.inputFocus = React.createRef();
        this.inputDetailFocus = React.createRef();
        this.focusStatus = false;
    }

    setFocusTextBox = (e) => {
        this.inputFocus.current.focus();
    }

    setFocusDetailTextBox = (e) => {
        this.inputDetailFocus.current.focus();
    }
    searchKeyPress = (e, btn) => {
        const { rootStore } = this.props;
        if (e.key === "Enter" && btn === "k") {
            //select_addr_forkakao(rootStore)
            fn_address_api(rootStore, "kakao");
        } else if (e.key === "Enter" && btn === "s") {
            document.getElementById("searchBtn").click();
        }
    };

    inputBoxDel = (e) => {
        const { rootStore } = this.props;
        fn_add_box_show(rootStore, false);
        rootStore.viewStore.setDetailSearchAddrDetail("");  // 주소 상세 검색란 초기화
        rootStore.viewStore.setDetailSearchAddr("");
        rootStore.viewStore.setKakaoMap("", "");
        rootStore.viewStore.initSearchAddrList();
        document.getElementById("addAdress").value = "";
    }

    componentDidMount() {
        // this.setFocusTextBox()
    }
    componentWillUnmount() {
    }
    componentWillUnmount() {
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        let addressArea = document.getElementById("addressListElement")
        addressArea.scrollTop = this.state.addressScroll;
        let keywordArea = document.getElementById("keywordListElement")
        keywordArea.scrollTop = this.state.keywordScroll;

        if (this.focusStatus == true) {
            this.setFocusDetailTextBox();
        } else {
            this.setFocusTextBox()
        }
    }

    addressScrollSet = (val) => {
        this.setState({ addressScroll: val })
    }

    addressScrollUp = () => {
        if (this.state.addressScroll >= 57)
            this.setState({ addressScroll: this.state.addressScroll - 57 })
    }

    addressScrollDown = () => {
        if (this.state.addressScroll + 289 < document.getElementById("addressListElement").scrollHeight)
            this.setState({ addressScroll: this.state.addressScroll + 57 })
    }

    keywordScrollUp = () => {
        if (this.state.keywordScroll >= 52)
            this.setState({ keywordScroll: this.state.keywordScroll - 52 })
    }

    keywordScrollDown = () => {
        if (this.state.keywordScroll + 98 < document.getElementById("keywordListElement").scrollHeight)
            this.setState({ keywordScroll: this.state.keywordScroll + 52 })
    }

    layerClose = () => {
        const { rootStore } = this.props;
        this.setState({ addressScroll: 0, keywordScroll: 0 });
        rootStore.layerStore.setLayerAddressSearch(false);
        document.getElementById("addAdress").value = "";
    }

    nullBoxCreate = (count) => {
        let areaArr = [1, 2, 3, 4, 5, 6, 7, 8]
        areaArr = areaArr.slice(count)
        let nullBox = areaArr.map((value) => {
            return <li key={value}><button disabled={true}></button></li>
        }
        );
        return nullBox
    }


    render() {
        const { rootStore } = this.props;
        let quickAddrLength = rootStore.settingStore.getQuickAddr.length;
        let searchMsg
        if (rootStore.viewStore.getSearchAddrResult === "many") {
            searchMsg = <><div className="etc many"><p>검색팁을 참고하여 검색해주세요.</p></div></>
        } else if (rootStore.viewStore.getSearchAddrResult === "ok") {
            searchMsg = ""
        } else {
            searchMsg = <><div className="etc empty"><p>검색팁을 참고하여 검색해주세요.</p></div></>
        }

        return (
            <div className={"layer_comm layer_address_search " + (rootStore.layerStore.getLayerAddressSearchView ? ' layer_open' : '')}>
                <div className="bg"></div>
                <div className="layer_content">
                    <div className="article_address_search">
                        <h1 className="section_tit">
                            <strong className="tit">주소검색</strong>
                            <span className="txt">
                                <em>자주쓰는 주소 키워드</em> 또는 <em>검색어 입력</em>으로 주소를 찾을 수 있습니다.
                            </span>
                        </h1>
                        <div className="clear_g">
                            <div className="section_left">
                                <div className="wrap_tit">
                                    <h2>자주 쓰는 주소 키워드</h2>
                                    <p>※ 키워드 등록/삭제 : [설정 &gt; 주소검색 설정] </p>
                                </div>
                                <div className="wrap_keyword">
                                    <div className="scroll scroll_hidden" id="keywordListElement">
                                        <ul className="list">
                                            {
                                                (Array.isArray(rootStore.settingStore.getQuickAddr) && rootStore.settingStore.getQuickAddr.length)
                                                    ?
                                                    rootStore.settingStore.getQuickAddr.map((obj, index) => (
                                                        <li key={"keyAddr" + index}
                                                            onClick={event => {
                                                                fn_add_box_show(rootStore, false);
                                                                rootStore.viewStore.setDetailNowSearchAddr(rootStore, obj.addr);
                                                                document.getElementById("addAdress").value = "";//수정해야될것
                                                                this.focusStatus = true;
                                                            }}
                                                        >
                                                            <button>{obj.addr}</button>
                                                        </li>
                                                    ))
                                                    :
                                                    null
                                            }
                                            {this.nullBoxCreate(quickAddrLength)}
                                        </ul>
                                    </div>
                                    <div className="btns">
                                        <button type="button" className="btn_up" onClick={this.keywordScrollUp}><span></span></button>
                                        <button type="button" className="btn_down" onClick={this.keywordScrollDown}><span></span></button>
                                    </div>
                                </div>
                                <div className="wrap_tit">
                                    <h2>주소 검색어 입력</h2>
                                    <div>
                                        <span className="ico_tip"></span>
                                        <span>도로명 + 건물번호, 동/읍/면/리 + 번지, 지역명 + 건물명</span>
                                    </div>
                                </div>
                                <div className="wrap_search">
                                    <input type="text" ref={this.inputFocus} placeholder="예) 판교역로 235, 삼성동 154-8" value={(rootStore.viewStore.getDetailSearchAddr != null) ? rootStore.viewStore.getDetailSearchAddr : ""}
                                        onKeyPress={e => this.searchKeyPress(e, "k")}
                                        onChange={event => rootStore.viewStore.setDetailSearchAddr(event.target.value)} autoFocus={true} onFocus={() => {
                                            this.focusStatus = false;
                                        }}
                                    />
                                    <button type="button" className="btn_clear" onClick={this.inputBoxDel}><span
                                        className="screen_out">입력값 삭제</span></button>
                                    <button type="submit"
                                        onClick={event => {
                                            fn_add_box_show(rootStore, false);
                                            //select_addr_forkakao(rootStore);
                                            fn_address_api(rootStore, "kakao");
                                            document.getElementById("addAdress").value = "";
                                        }
                                        }
                                    >검색</button>
                                </div>
                                <div className="wrap_tit">
                                    <h2>주소 목록 <span>(검색결과 <em>{(rootStore.viewStore.getSearchAddrCount > 0) ? rootStore.viewStore.getSearchAddrCount : rootStore.viewStore.getSearchAddrList.length}건</em>)</span></h2>
                                </div>
                                <div className="wrap_address_list">
                                    <div className="scroll scroll_hidden" id="addressListElement">
                                        {searchMsg}
                                        <ul className="list"
                                            // onClick={()=>{this.setFocusDetailTextBox;this.focusStatus = true; }}
                                            onClick={() => {
                                                //document.getElementById("addAdress").value = ""; 
                                                this.focusStatus = true
                                            }}
                                        >
                                            {
                                                (Array.isArray(rootStore.viewStore.getSearchAddrList) && rootStore.viewStore.getSearchAddrList.length)
                                                    ?
                                                    rootStore.viewStore.getSearchAddrList.map((addr, index) => (
                                                        <AddressSearchViewItem key={"orderAddr" + index} rootStore={rootStore} addr={addr} addressScrollSet={this.addressScrollSet} />
                                                    ))
                                                    :
                                                    null
                                            }
                                        </ul>

                                    </div>
                                    <div className="btns">
                                        <button type="button" className="btn_up" onClick={this.addressScrollUp}><span></span></button>
                                        <button type="button" className="btn_down" onClick={this.addressScrollDown}><span></span></button>
                                    </div>
                                </div>
                            </div>
                            <div className="section_right">
                                <div className="wrap_address_detail">
                                    <h3>상세주소 입력</h3>
                                    {
                                        (rootStore.viewStore.getAddrApiName.api === "kakao")
                                            ? <KakaoMap rootStore={rootStore} />
                                            : <NaverMapComponent rootStore={rootStore} />
                                    }
                                    <div className="box_txt">
                                        {
                                            (rootStore.viewStore.getAddrBoxShowFlag)
                                                ?
                                                <div className="inner">
                                                    <h4>{rootStore.viewStore.getSelectRoadAddrVal  ?
                                                        rootStore.viewStore.getSelectAddrVal : rootStore.viewStore.getClickedAddress}</h4>
                                                    {/* {rootStore.viewStore.getDetailSearchAddrDetail} */}
                                                    <p>(도로명) {rootStore.viewStore.getSelectRoadAddrVal || ""}</p>
                                                </div>
                                                : <div className="inner disabled"></div>
                                        }
                                    </div>
                                    <div className="box_inp">
                                        <input type="text" id="addAdress" ref={this.inputDetailFocus} placeholder="상세주소 입력" maxLength={30}
                                            onChange={event => event.target.value}
                                            disabled={(rootStore.viewStore.getAddrBoxShowFlag) ? false : true}
                                            onKeyPress={e => this.searchKeyPress(e, "s")}
                                        //    onBlur={()=>{this.focusStatus = false}}
                                        />
                                    </div>
                                    <div className="box_btn">
                                        <button id="searchBtn"
                                            onClick={event => {
                                                fn_update_address(rootStore, document.getElementById("addAdress").value);
                                                document.getElementById("addAdress").value = "";
                                                this.focusStatus = false
                                            }}
                                        ><span>주소지 설정</span></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="btn_close">
                            <button
                                onClick={() => {
                                    this.focusStatus = false
                                    this.layerClose();
                                }}
                            ><span>닫기</span></button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AddressSearchView;